module.exports = __webpack_public_path__ + "static/media/filter.fc13a134.svg";